import { SET_CURRENT_USER, LOGOUT, SET_CURRENT_LANGUAGE } from './types';

export const setCurrentUser = (user) => ({
  type: SET_CURRENT_USER,
  payload: user,
});

export const logout = () => ({
  type: LOGOUT,
});

export const setLanguageDispatch = (lang) => ({ 
  type: SET_CURRENT_LANGUAGE, 
  payload: lang 
});